import * as Yup from 'yup';

export const pesquisaSchema = Yup.object({
  codigo_grupo_empresa: Yup.number()
    .typeError('Selecione um Grupo de Empresa')
    .required('Selecione um Grupo de Empresa'),
  codigo_familia: Yup.number().nullable(),
  codigo_conta: Yup.number().nullable(),
  data_inicio: Yup.date().nullable(),
  data_fim: Yup.date().nullable(),
  filtro_escritura: Yup.string().oneOf(['todos', 'com', 'sem']).required(),
  filtro_emissao: Yup.string().oneOf(['todos', 'com', 'sem']).required(),
}).test(
  'periodo-ou-cliente',
  'Informe período de quitação ou cliente específico',
  (val) =>
    !!val.codigo_conta || (!!val.data_inicio && !!val.data_fim)
);

export const validarPesquisa = async (valores) => {
  try {
    await pesquisaSchema.validate(valores, { abortEarly: false });
    return { valido: true, erros: [] };
  } catch (err) {
    return {
      valido: false,
      erros: err.errors || ['Erro de validação'],
    };
  }
};
